import type { MouseEventHandler } from 'react';
import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/utils';

interface CustomerLinkProps {
  customerId: string;
  /** Raw name from the caller's payload; used when there is no ERP name. */
  customerName: string | null;
  /**
   * The customer's name as the source ERP renders it — the `erpDisplayName`
   * field on the payload.
   */
  erpDisplayName: string | null | undefined;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export function CustomerLink({
  customerId,
  customerName,
  erpDisplayName,
  className,
  onClick,
}: CustomerLinkProps) {
  return (
    <Link
      to="/accounts-receivable/collections/$customerId"
      params={{ customerId }}
      onClick={onClick}
      className={cn(
        'text-sm font-medium text-primary hover:underline',
        className,
      )}
    >
      {erpDisplayName ?? customerName ?? '—'}
    </Link>
  );
}
